// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + {"266":"cc4e7cf705f6fa2306f2ae82a7565495","284":"413b83843c409412b45a0c2692fc674f"}[chunkId] + ".js";
};